import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { musicVideoCreateSceneModalSelector } from 'core/store/reducers/appReducer/AppSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const MusicVideoCreateSceneModal = lazy(() => import('./MusicVideoCreateSceneModal'));

function LazyMusicVideoCreateSceneModal() {
	const { open } = useSelector(musicVideoCreateSceneModalSelector);

	return (
		<LazyRenderLayer isShown={open}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<MusicVideoCreateSceneModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyMusicVideoCreateSceneModal;
